import React from 'react';

import UniversalCard from 'components/cards/listing/UniversalCard';
import { CardEventSource } from 'utils/entities';
import { DecodedRouteParams } from 'config/routes';
import { Link } from 'react-router5';
import styled from '@emotion/styled';
import { DefaultUniversalCardProps } from './WrapperFreeUniversalCard';
import { routeByPoiType } from 'utils/marketplaceRoutes';


export type LinkedUniversalCardProps = DefaultUniversalCardProps & {
  eventSource: CardEventSource,
  notificationTags?: string[];
  sectionName?: string;
};

const LinkWrapper = styled.div`
  width: 100%;

  > a {
    text-decoration: inherit;
    width: 100%;
  }
`;

export const LinkedUniversalCard: React.FC<LinkedUniversalCardProps> = (props) => {
  const { type, id, eventSource, sectionName } = props;

  const params: DecodedRouteParams = {
    id,
    dealType: undefined,
    term: undefined,
    tracking_event_source: eventSource,
  };

  if (sectionName) {
    params.tracking_event_section_name = sectionName;
  }

  return (
    <LinkWrapper>
      <Link
        data-auto="listed-bulletin-clickable"
        routeName={routeByPoiType(type)}
        routeParams={params}
      >
        <UniversalCard showPriceDropLabel {...props} />
      </Link>
    </LinkWrapper>
  );
};
